import styled from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'

const Block = styled.div`
  position: fixed;
  z-index: 10;
  display: flex;
  align-items: flex-end;
`

const ButtonWrapper = styled.div`
  box-shadow: ${sv.shadow.medium};
  border-radius: 100%;
`

export default { Block, ButtonWrapper }
